import { apiClient } from '@/lib/api';
import { ENDPOINTS } from '@/lib/api/endpoints';
import type { GrupoDeModulos, Plan } from '../types/admin.types';

class PlansService {
  async getAll(): Promise<Plan[]> {
    return apiClient.get<Plan[]>(ENDPOINTS.PLANS);
  }

  async getById(id: string): Promise<Plan> {
    return apiClient.get<Plan>(ENDPOINTS.PLAN_BY_ID(id));
  }

  /** El catálogo de módulos agrupado, para el editor de módulos del plan. */
  async getCatalogoDeModulos(): Promise<GrupoDeModulos[]> {
    const r = await apiClient.get<{ catalog: GrupoDeModulos[] }>(
      `${ENDPOINTS.PLANS}/catalogo-de-modulos`
    );
    return r.catalog;
  }

  async create(data: Partial<Plan>): Promise<Plan> {
    return apiClient.post<Plan>(ENDPOINTS.PLANS, data);
  }

  async update(id: string, data: Partial<Plan>): Promise<Plan> {
    return apiClient.patch<Plan>(ENDPOINTS.PLAN_BY_ID(id), data);
  }

  async remove(id: string): Promise<void> {
    return apiClient.delete(ENDPOINTS.PLAN_BY_ID(id));
  }
}

export const plansService = new PlansService();
